import type { IHttpApi } from '@cian/http-api/shared';

import {
  fetchGetNewbuildingsSummary,
  type TGetNewbuildingsSummaryResponse,
} from '../../repositories/property-comparison/v1/get-newbuildings-summary';
import type { IAiSummaryResponse } from '../../types/newbuildingsSummary';
import { assertGetNewbuildingsSummaryError } from './assert';

export interface IFetchNewbuildingsSummary {
  httpApi: IHttpApi;
}

export async function fetchNewbuildingsSummary({ httpApi }: IFetchNewbuildingsSummary): Promise<IAiSummaryResponse> {
  const response = (await fetchGetNewbuildingsSummary({ httpApi })) as TGetNewbuildingsSummaryResponse;

  assertGetNewbuildingsSummaryError(response);

  return {
    ...response.response,
    summarization: response.response.summarization.map(item => ({
      ...item,
      priceRange: item.priceRange ?? undefined,
      highlights: item.highlights
        ? {
            ...item.highlights,
            items: item.highlights.items.map(highlight => ({
              ...highlight,
              subtitle: highlight.subtitle ?? undefined,
            })),
          }
        : undefined,
      features: item.features ?? undefined,
    })),
  };
}
